import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {SideMenuService} from "../../../../../services/side-menu.service";
import {MultiClaimDocumentsComponent} from "../../../../multi-claim-documents/multi-claim-documents.component";
import { ClaimService } from "../../../../../services/claim.service";
import { DocumentHelperService } from "../../../../../services/document-helper.service";
import { TransactionInfoService } from "../../../../../services/transaction-info.service";
import { HttpClient } from "@angular/common/http";
import { DocumentFormFactoryService } from "../../../../../services/document-form-factory.service";
import { ClaimTypes } from "../../../../../model/claim-type.model";
import { SpinnerService } from '../../../../../core/spinner/spinner.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {Claim} from "../../../../../model/claim.model";

declare var $: any;

@Component({
    selector: 'app-rerouting-upload-document',
    templateUrl: './rerouting-upload-document.component.html',
    styleUrls: ['./rerouting-upload-document.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReroutingUploadDocumentComponent extends MultiClaimDocumentsComponent implements OnInit {

    public upLoadFileModel: FormGroup;
    showTotalBox = false;
    claim: Claim;
    
    constructor(private fb: FormBuilder,
        public sideMenuService: SideMenuService, 
        claimService: ClaimService,
        documentHelperService: DocumentHelperService,
        transactionInfoService: TransactionInfoService,
        http: HttpClient,
        documentFormFactoryService: DocumentFormFactoryService, spinnerService: SpinnerService, modalService: NgbModal) {
                super(claimService, documentHelperService, transactionInfoService, http, documentFormFactoryService, spinnerService, modalService);
                this.setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT]);
                this.setupMultiClaimant();
    }

    ngOnInit() {

        this.pushGAViewRerouteDocs();
        this.upLoadFileModel = this.fb.group(
            {
                airTicket: [],
                carrierCertificate: [],
                originDoc: [],
                otherItems: this.fb.array([this.createItem()])

            });
            super.ngOnInit();
            this.claim = this.claimService.getClaim();
    }

    addFile() {
        let items = this.upLoadFileModel.get('otherItems') as FormArray;
        items.push(this.createItem());
    }

    createItem(): FormGroup {
        // setTimeout(() => {
        //   console.log('lossType1111', this.el.nativeElement.value);
        //   this.selectType = this.el.nativeElement.value;
        // });
        return this.fb.group({
            otherFile: [],


            // detail: this.fb.group(that.createDetail('mobile'))
        });
    }

    showModal() {
        this.showTotalBox = true;
    }

    getData(msg) {
        this.showTotalBox = msg;
    }

    goToNext() {
        this.sideMenuService.emitClaimComplete({claimTypeId: 10, subMenuIndex: 2});
        this.sideMenuService.emitProgress(1);
    }

    //Google Analytics
    pushGAViewRerouteDocs() {
        (<any>window).dataLayer.push({
            'pageStep': 'Travel Re-routing – Document Upload',
            'vPath': '/claim/travel-re-routing/documents',
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 6},	//Step6-DocumentUpload
                }
            }
        });
    }

}
